import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Save, ChevronsUpDown } from 'lucide-react'
import { memo } from 'react'

interface SaveViewDropdownProps {
  onUpdateView: () => void
  onSaveAsNewView: () => void
  canUpdateView: boolean
  isSaving?: boolean
}

const SaveViewDropdown = ({
  onUpdateView,
  onSaveAsNewView,
  canUpdateView,
  isSaving = false,
}: SaveViewDropdownProps) => {
  // Non-owner: simple "Save as New View" button (no dropdown needed)
  if (!canUpdateView) {
    return (
      <Button
        size="sm"
        className="gap-1 text-xs"
        onClick={onSaveAsNewView}
        disabled={isSaving}
      >
        <Save className="h-3.5 w-3.5" />
        Save as New View
      </Button>
    )
  }

  // Owner: dropdown with "Update View" + "Save as New View"
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" className="gap-1 text-xs" disabled={isSaving}>
          <Save className="h-3.5 w-3.5" />
          {isSaving ? 'Updating...' : 'Update View'}
          <ChevronsUpDown className="size-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onUpdateView}>Update View</DropdownMenuItem>
        <DropdownMenuItem onClick={onSaveAsNewView}>
          Save as New View
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

const MemoizedSaveViewDropdown = memo(SaveViewDropdown)

MemoizedSaveViewDropdown.displayName = 'SaveViewDropdown'

export { MemoizedSaveViewDropdown as SaveViewDropdown }
